<template>
  <div class="home">
    <h3 class="title">คำนวณ DOPAmine drip rate </h3>
    <ul id="input">
      <li>
        Weight
        <input type="range" min="30" max="100" step="1" v-model="wt">
        <input class="input" type="integer" v-model="wt" size="3px"> kg
      </li>
      <li>
        Dose
        <input type="range" min="1" max="50" step="1" v-model="dopadose">
        <input class="input" type="integer" v-model="dopadose" size="2px"> mcg/kg/min
      </li>
    </ul>
<br>
    <h4>Conc. 1:1 (250 mg/250 ml)</h4>
    <div id="dose">➡️ {{driprate(250,250).toFixed(1)}} microdrop/min, ml/hr</div>
    <span class="desc">- ต้องจ่าย DOPAmine (250mg/10ml) {{soluseqty(250,250)}} amp กับสารน้ำ {{soluseqty(250,250)}} bag ต่อ 1 วัน </span>
    <h4>Conc. 2:1 (500 mg/250 ml)</h4>
    <div id="dose">➡️ {{driprate(250,125).toFixed(1)}} microdrop/min, ml/hr</div>
    <span class="desc">- ต้องจ่าย DOPAmine (250mg/10ml) {{soluseqty(500,250)*2}} amp กับสารน้ำ {{soluseqty(500,250)}} bag ต่อ 1 วัน </span>
    <br>

    
    <h3 class="title">คำนวณ DOPAmine dose จาก drip rate</h3>
    <ul id="input">
      <li>
        Weight
        <input type="range" min="30" max="100" step="1" v-model="wt">
        <input class="input" type="integer" v-model="wt" size="3px"> kg
      </li>
      <li>
        Drip rate
        <input type="range" min="1" max="50" step="1" v-model="dr">
        <input class="input" type="integer" v-model="dr" size="3px"> microdrop/min, ml/hr
      </li>
    </ul>
    <h4>Conc. 1:1 (250 mg/250 ml)</h4>
    <div id="dose">➡️ {{dose(250,250).toFixed(1)}} mcg/kg/min</div>
    <span class="desc">- ต้องจ่าย DOPAmine (250mg/10ml) {{soluseqtyfromdr(250)}} amp กับสารน้ำ {{soluseqtyfromdr(250)}} bag ต่อ 1 วัน</span>
    <h4>Conc. 2:1 (500 mg/250 ml)</h4>
    <div id="dose">➡️ {{dose(500,250).toFixed(1)}} mcg/kg/min</div>
    <span class="desc">- ต้องจ่าย DOPAmine (250mg/10ml) {{soluseqtyfromdr(250)*2}} amp กับสารน้ำ {{soluseqtyfromdr(250)}} bag ต่อ 1 วัน</span>
  
  <h3 class="title">⚕️ Dosage</h3>
    <div id="sop">
      <b>ผู้ใหญ่</b>
      <br>
      initial dose 2 – 5 mcg/kg/min สามารถปรับเพิ่มขนาดยาครั้งละ 5 - 10 mcg/kg/min ขนาดยาสูงสุดไม่เกิน 50 mcg/kg/min เพราะถ้าขนาดยาสูงกว่า 50 mcg/kg/min มีโอกาสเกิด renal shutdown ได้ ควร monitor ดู urine flow ถ้าลดลงควรปรับลด infusion rate ลง
      
      <br>
      <b>เด็ก</b>
      <br>
      initial dose 2 - 5 mcg/kg/min ขนาดยาสูงสุดไม่เกิน 50 mcg/kg/min
    </div>

  <h3 class="title">📄 Preparation for Administration</h3>
  <div id="sop">
      <b> เตรียม Conc. 1:1 (250 mg/250 ml)</b>
      <br>
      <ol id="sop">
        <li>นำ D5W หรือ NSS ขวด 250 ml มาดูดออก 10 ml</li>
        <li>ดูดยา DOPAmine 1 amp (250 mg) เติมลงในสารน้ำที่เตรียมไว้ พลิกถุงยาไปมาให้ยาเข้ากัน</li>
        <li>ยามีความคงตัว 24 ชั่วโมงหลังจากผสม</li>
      </ol>
      <b>เตรียม Conc. 2:1 (500 mg/250 ml)</b>
      <br>
      <ol id="sop">
        <li>นำ D5W หรือ NSS ขวด 250 ml มาดูดออก 20 ml</li>
        <li>ดูดยา DOPAmine 2 amp (500 mg) เติมลงในสารน้ำที่เตรียมไว้ พลิกถุงยาไปมาให้ยาเข้ากัน</li>
        <li>ยามีความคงตัว 24 ชั่วโมงหลังจากผสม</li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: "dopa",
  data() {
    return {
      dopadose: 3,
      wt: 50,
      dr: 3
    };
  },
  methods: {
    driprate(conc, vol) {
      return (((this.dopadose * this.wt * 60) / conc) * vol) / 1000;
    },
    soluseqty(conc, vol) {
      return Math.ceil((this.driprate(conc, vol) * 24) / vol);
    },
    dose(conc, vol) {
      return (conc * 1000 * this.dr) / vol / this.wt / 60;
    }    ,
    soluseqtyfromdr(vol) {
      return Math.ceil(this.dr*24/vol);
    }
  },
  computed: {
    drugusemg() {
      return Math.round((this.wt * this.dopadose * 60 * 24) / 1000);
    }
  }
};
</script>

<style scope >
div {
  margin-top: 10px;
}
ul#input li {
  display: list-item;
  list-style-type: none;
}
div#dose {
  font-size: 20px;
  color: black;
  background-color: #fccbcb;
}

.input {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #364f6b;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px thin #4f9bb2;
}
.desc {
  font-size: 12px;
  color: #be5683;
}
</style>